import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { S3_URL } from "../constants";
import { GET_PRESIGN_URL } from "../graphql/presignUrl/query";

/**
 * Upload a chat image or voice clip and return its public URL, which Meta fetches to deliver it.
 *
 * The content type is signed into the URL and sent on the PUT, so S3 serves the file as what it
 * is: Messenger refuses an audio attachment served as the default "file/*; image/*".
 */
export const uploadChatMedia = async (client, blob, ext, contentType) => {
    const name = `chat-${uuidv4()}.${ext}`;
    const { data } = await client.query({
        query: GET_PRESIGN_URL,
        variables: { name, contentType },
        fetchPolicy: "network-only",
    });
    const url = data?.preSignedUrl?.url;
    if (!url) throw new Error("no upload url");
    await axios.put(url, blob, { headers: { "Content-Type": contentType } });
    return `${S3_URL}${name}`;
};

/**
 * The best format this browser can record that Messenger will play: mp4/aac where supported
 * (Safari, current Chrome and Edge), webm otherwise.
 */
export const pickAudioFormat = () => {
    const options = [
        { mime: "audio/mp4", ext: "m4a" },
        { mime: "audio/mp4;codecs=mp4a.40.2", ext: "m4a" },
        { mime: "audio/webm;codecs=opus", ext: "webm" },
        { mime: "audio/webm", ext: "webm" },
    ];
    const ok = typeof MediaRecorder !== "undefined" && MediaRecorder.isTypeSupported;
    return options.find((o) => ok && MediaRecorder.isTypeSupported(o.mime)) || null;
};
